import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { AuthGuardService as AuthGuard } from '@services/router-guards/auth-guard.service';

import { PageNotFoundComponent } from '@modules/page-not-found/page-not-found.component';
import { LanguageGuardService as LanguageGuard } from '@services/router-guards/language-guard.service';
import { routePathName } from '@app/app.models';
import { LoginPageGuardService } from '@services/router-guards/login-page-guard.service';
import { LoginComponent } from '@modules/manager/modules/auth/modules/login';
import { ResetPasswordComponent } from '@modules/manager/modules/auth/modules/reset-password';
import { OAuthCallbackComponent } from '@modules/manager/modules/auth/modules/callback';

const routes: Route[] = [
	{
		path: routePathName.signIn,
		component: LoginComponent,
		canActivate: [LoginPageGuardService]
	},
	{
		path: routePathName.oauthCallback,
		component: OAuthCallbackComponent,
		canActivate: [LanguageGuard]
	},
	{
		path: routePathName.resetPassword,
		component: ResetPasswordComponent,
		canActivate: [LanguageGuard]
	},
	{
		path: '',
		loadChildren: () => import('@modules/manager').then((m) => m.ManagerModule),
		canActivate: [LanguageGuard]
	},
	{
		path: '**',
		component: PageNotFoundComponent,
		canActivate: [LanguageGuard]
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { enableTracing: false, relativeLinkResolution: 'legacy' })],
	exports: [RouterModule]
})
export class AppRoutingModule {}
